import React from "react";
import { Snackbar, Button } from "@mui/material";
import { useRegisterSW } from "virtual:pwa-register/react";

/**
 * Registers the Workbox service worker generated by vite-plugin-pwa.
 *
 * The worker exists mainly so Chrome will treat the app as installable: its
 * install prompt still requires a worker with a fetch handler, even though the
 * browser menu's "Install app" no longer does.
 *
 * Updates are offered rather than applied, so a deploy can never reload a
 * half-finished intake or charting form out from under a clinician.
 */
const ServiceWorkerUpdater = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
  } = useRegisterSW();

  return (
    <Snackbar
      open={needRefresh}
      message="A new version of HealthDesk is ready."
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={(_, reason) => {
        // Staying open on a stray click is deliberate: dismissing by accident
        // would leave the user on the old build with no way back to this prompt.
        if (reason !== "clickaway") setNeedRefresh(false);
      }}
      action={
        <Button
          color="inherit"
          size="small"
          // A plain reload: the new worker already took over by itself (skipWaiting
          // in vite.config.js), so updateServiceWorker(true) waited for a takeover
          // that had already happened and never reloaded.
          onClick={() => window.location.reload()}
        >
          Reload
        </Button>
      }
    />
  );
};

export default ServiceWorkerUpdater;
